import { module } from "modujs";
import formMixin from "../vue-mixins/formMixin";
const { required, minLength, maxLength, email, sameAs } = window.validators;

const defaultValidation = {
    lastName: {
        required,
    },
    firstName: {
        required,
    },
    email: {
        required,
        email,
    },
    phone: {
        // required,
    },
    address: {
        // required,
    },
    postalCode: {
        // required,
    },
    city: {
        // required,
    },
    region: {
        required,
    },
    expertise: {
        required,
    },
    role: {
        required,
    },
    coverletter: {
        required,
    },
    condition: { sameAs: sameAs( () => true ) }
}

const passwordValidation = {
    password: {
        required,
        minLength: minLength(8)
    },
    confirmPassword: {
        required,
        sameAsPassword: sameAs('password')
    }
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Initial values are used to prefill the form.
        this.initialValues = JSON.parse(this.getData('values'))
        this.userIsLogged = this.getData('is-logged')

        // Init vue
        this.initVue();
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default);

        /////////////////////////
        // Import captcha
        const captcha = JSON.parse(this.el.getAttribute('data-captcha'));

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            mixins: [
                formMixin,
            ],

            data: () => {
                return {
                    submitStatus: '',
                    captcha: captcha,
                    lastName: "",
                    firstName: "",
                    email: "",
                    password: '',
                    confirmPassword: '',
                    phone: "",
                    age: "",
                    address: "",
                    postalCode: "",
                    city: "",
                    region: "",
                    expertise: "",
                    role: "",
                    coverletter: "",
                    condition: "",
                    newsletter: true,
                    weeklyNews: true,
                };
            },

            validations: (moduleInstance.userIsLogged == 'true') ? defaultValidation : {...defaultValidation, ...passwordValidation},

            created() {
                this.moduleInstance = moduleInstance
                this.initForm !== undefined && this.initForm()
            }
        });
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
